import { Component, Input, EventEmitter, input, ChangeDetectionStrategy } from '@angular/core';

import type { HelpTranslationLinkMapKey } from '@core/help-articles-legacy';
import { HelpArticlesDirective } from '@core/help-articles-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DividerComponent,
  IconButtonComponent,
  IconColorDirective,
  IconComponent,
} from '@core/user-interface-legacy';

import type { WalkthroughComponentProperties } from '../../types';

@Component({
  selector: 'rt-walkthrough-post',
  imports: [
    IconButtonComponent,
    IconColorDirective,
    ButtonComponent,
    IconComponent,
    TranslatePipe,
    DividerComponent,
    HelpArticlesDirective,
  ],
  templateUrl: './walkthrough-post.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './walkthrough-post.component.less',
})
export class WalkthroughPostComponent implements WalkthroughComponentProperties {
  public readonly currentStep = input<number>(undefined!);
  public readonly stepsTotal = input<number>(undefined!);

  public readonly heading = input<string>(undefined!);
  public readonly description = input<string>(undefined!);

  public readonly ctaText = input<string>(undefined!);
  @Input() public ctaIcon?: IconName = undefined;
  @Input() public helpArticleKey?: HelpTranslationLinkMapKey;

  public cancel = new EventEmitter<void>();
  public finish = new EventEmitter<void>();
  public next = new EventEmitter<void>();

  public closeTooltip() {
    this.cancel.emit();
  }
}
